import { observable, action } from 'mobx';
import { saveAs } from 'file-saver';
import{ http, addVisitLog, history} from 'libs';
import { message } from 'antd';
import moment from "moment";

class Store {
  @observable records = [];
  @observable record = {};
  @observable stockOutItemList = [];
  @observable expressList = [];
  @observable fetching = false;
  @observable exportCertLoading = false;
  @observable formVisible = false;
  @observable formLoading = false;
  @observable selectDisable = false;
  @observable formWmsVisible = false;
  @observable formLogVisible = false;
  //搜索条件
  @observable page = 1;
  @observable pageSize = localStorage.getItem('orderPageSize') || 10;
  @observable pageTotal = 0;
  @observable projectNo = null;
  @observable purchaseNo = null;
  @observable brandName = null;
  @observable goodsName = null;
  @observable catalog = null;
  @observable applyUserName = null;
  @observable invoiceTitle = null;
  @observable factoryCode = null;
  @observable deviceSerialNo = null;
  @observable hospitalName = null;
  @observable centerNo = null;
  @observable name = null;
  @observable phone = null;
  @observable address = null;
  @observable createTime = null;
  @observable orderSn = null;

  @observable updateTime = null;
  @observable projectList = [];
  @observable typeObj = {
    "Sale": "销售",
    "RentToSale": "销售",
    "Rent": "租赁",
    "Store": "仓储",
    "Testing": "计量",
    "Transfer": "转运",
  };

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    localStorage.setItem('orderPageSize',size);
    this.fetchRecords()
}

fetchRecord = (info) => {
  this.projectList = [];
  this.formLoading = true;
  let query = {
    orderItemId: info.orderItemId,
    catalog: info.catalog

  }
  http.get('/javaApi/front/project/listAll',{ params: {orgId:info.orgId} })
  .then(action('a', res => {
    this.projectList = res.data.result; 
}))
  http.get('/javaApi/front/clinicalOrder/getDetail',{ params: query })
    .then(action('a', res => {
      this.record = res.data.result; 
  }))
    .finally(action('b', () => this.formLoading = false))
};

  fetchRecords = () => {
    this.fetching = true;
    let query = {
      catalog: this.catalog, // 订单类型(销售Sale/租赁Rent/仓储Store/计量Testing/转运Transfer)
      brandName: this.brandName, // 品牌
      goodsName: this.goodsName, // 产品
      factoryCode: this.factoryCode, // 货号
      projectNo: this.projectNo, // 项目号
      invoiceTitle: this.invoiceTitle, // 发票抬头
      applyUserName: this.applyUserName, // 申请人ID
      purchaseNo: this.purchaseNo, // PO号
      deviceSerialNo: this.deviceSerialNo, // 序列号
      hospitalName: this.hospitalName, // 医院名称
      centerNo: this.centerNo, // 中心号
      name: this.name, // 联系人
      phone: this.phone, // 手机号
      address: this.address, // 地址
      orderSn: this.orderSn, // 销售订单号
      createTime1: this.createTime&&moment(this.createTime[0]).format('YYYY-MM-DD'),
      createTime2: this.createTime&&moment(this.createTime[1]).format('YYYY-MM-DD'),
    }
    http.post('/javaApi/front/clinicalOrder/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize,
      param: query 
    })
      .then(action('a', res => {
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.fetching = false))
  };

  async exportLog(data,isDetail) {
    let url = ''
    if (isDetail === 'cert') {
      url = '/javaApi/front/clinicalOrder/downloadCertificate';
    }else if(isDetail){
      url = '/javaApi/front/export/orderDeviceExcel';
    }else{
      url = '/javaApi/front/export/orderExcel';
    }
    const res = await http({
      url: url,
      method: 'get',
      params:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = (isDetail) => {
    if (isDetail === 'cert') {
      //证书导出必须选择时间并且小于等于31天
      if (!this.createTime||(moment(this.createTime[1])-moment(this.createTime[0]))/1000/86400 > 180) {
        return message.error('请选择导出时间且最长支持导出180天');
      }
      this.exportCertLoading = true;
    }
    this.fetching = true;
    const query = { 
      pageNo: this.page,
      pageSize: this.pageSize,
      catalog: this.catalog, // 订单类型(销售Sale/租赁Rent/仓储Store/计量Testing/转运Transfer)
      brandName: this.brandName, // 品牌
      goodsName: this.goodsName, // 产品
      factoryCode: this.factoryCode, // 货号
      projectNo: this.projectNo, // 项目号
      invoiceTitle: this.invoiceTitle, // 发票抬头
      applyUserName: this.applyUserName, // 申请人ID
      purchaseNo: this.purchaseNo, // PO号
      deviceSerialNo: this.deviceSerialNo, // 序列号
      hospitalName: this.hospitalName, // 医院名称
      centerNo: this.centerNo, // 中心号
      name: this.name, // 联系人
      phone: this.phone, // 手机号
      address: this.address, // 地址
      orderSn: this.orderSn, // 销售订单号
      createTime1: this.createTime&&moment(this.createTime[0]).format('YYYY-MM-DD'),
      createTime2: this.createTime&&moment(this.createTime[1]).format('YYYY-MM-DD'),
    }
    if (isDetail === 'cert') {
      message.warning('证书文件较大，下载时间较长，请耐心等待');
      http.post('/javaApi/front/clinicalOrder/getCertificateList',{ 
        pageNo: this.page,
        pageSize: this.pageSize,
        param: query 
      }).then(res=>{
        if (res.data.code===999) {
          this.exportLog(query,isDetail).then(res => {
            if (res) {
              let url = window.URL.createObjectURL(
                new Blob([res.data], {
                  type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                }),
              );
              let name = '证书.zip';
              this.fetching = false;
              this.exportCertLoading = false;
              saveAs(url,name);
            } else {
              this.fetching = false;
              this.exportCertLoading = false;
              message.error('导出失败');
            }
          });
        }else{
          message.error(res.data?.error);
          this.fetching = false;
          this.exportCertLoading = false;
        }
      }).catch(err=>{
        this.fetching = false;
        this.exportCertLoading = false;
      })
      addVisitLog({
        pageName: '导出证书',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: 'OrderExportCert',
        eventName: '导出证书',
      })
    }else{
      this.exportLog(query,isDetail).then(res => {
        if (res) {
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          );
          let name = '';
          if(isDetail){
            name = '订单明细列表.xlsx';
          }else{
            name = '订单列表.xlsx';
          }
          this.fetching = false;
          this.exportCertLoading = false;
          saveAs(url,name);
        } else {
          this.fetching = false;
          this.exportCertLoading = false;
          message.error('导出失败');
        }
      });
      let eventCode = '';
      let eventName = '';
      if (isDetail) {
        eventCode = 'ExportOrderDetail';
        eventName = '导出订单明细';
      }else{
        eventCode = 'ExportOrder';
        eventName = '导出订单行';
      }
      addVisitLog({
        pageName: eventName,
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: eventCode,
        eventName: eventName,
      })
    }
  }

  async fetchOrgList(value) {
    const query = {
      name: value,
    }
    return http.get('/api/customer/organization/',{ params: query })
    // .then((response) => response.json())
      .then((res) =>{
        if (res&&res.length) {
          return res.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        }else{
          return []
        }
      }
      );
  }

  async fetchCustomerList(value,id) {
    if (id) {
      const query = {
        organization_id: id,
        name: value,
        
      }
      return http.get('/api/customer/customer/',{ params: query })
        .then((res) =>
          res.map((item) => ({
            ...item,
            label: item.name,
            value: item.id, 
          })),
        );
    }
  }

  onRowsChange = (rows, keys) => {
    console.log(rows, keys)
  }

  showForm = (info) => {
    this.fetchRecord(info);
    this.formVisible = true;
  }

  showWmsForm = (info) => {
    this.record = info;
    this.stockOutItemList = info.stockOutItemList || [];
    this.formWmsVisible = true
  }

  showLogistics = (info) => {
    this.expressList = info || [];
    this.formLogVisible = true
  }
}

export default new Store()